import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Paper,
  Divider,
  Button,
  ButtonGroup
} from '@mui/material';
import {
  Send as SendIcon,
  Add as AddIcon,
  History as HistoryIcon
} from '@mui/icons-material';

const ChatDrawer = ({ onSendMessage, messages = [], selectedContext = null }) => {
  const [inputMessage, setInputMessage] = useState('');

  const handleSend = () => {
    if (inputMessage.trim()) {
      onSendMessage(inputMessage);
      setInputMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  // Canned prompts
  const cannedPrompts = [
    { label: 'Add pecuniary bequests', value: 'Add pecuniary bequests' },
    { label: 'Customize takers of last resort', value: 'Customize takers of last resort' }
  ];

  const handleCannedPrompt = (prompt) => {
    let fullPrompt = prompt.value;
    if (selectedContext) {
      fullPrompt += ` in ${selectedContext.article} - ${selectedContext.section}`;
    }
    setInputMessage(fullPrompt);
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h6">AI Drafting Assistant</Typography>
        {selectedContext && (
          <Typography variant="caption" color="text.secondary">
            Editing: {selectedContext.docName} - {selectedContext.section}
          </Typography>
        )}
      </Box>

      {/* Messages Area */}
      <Box 
        sx={{ 
          flexGrow: 1, 
          overflowY: 'auto', 
          p: 2,
          bgcolor: 'grey.50'
        }}
      >
        {messages.length === 0 ? (
          <Typography variant="body2" color="text.secondary" align="center">
            Select a document section and start customizing with AI
          </Typography>
        ) : (
          messages.map((message, index) => (
            <Paper 
              key={index} 
              sx={{ 
                p: 2, 
                mb: 2,
                bgcolor: message.sender === 'user' ? 'primary.light' : 'background.paper',
                color: message.sender === 'user' ? 'primary.contrastText' : 'text.primary'
              }}
            >
              <Typography variant="body2">{message.text}</Typography>
            </Paper>
          ))
        )}
      </Box>

      {/* Canned Prompts */}
      <Box sx={{ p: 2, borderTop: 1, borderColor: 'divider' }}>
        <Typography variant="caption" color="text.secondary" gutterBottom>
          Quick Actions:
        </Typography>
        <ButtonGroup size="small" variant="outlined" sx={{ mt: 1 }}>
          {cannedPrompts.map((prompt, index) => (
            <Button 
              key={index}
              onClick={() => handleCannedPrompt(prompt)}
              sx={{ textTransform: 'none' }}
            >
              {prompt.label}
            </Button>
          ))}
        </ButtonGroup>
      </Box>

      {/* Input Area */}
      <Box sx={{ p: 2, borderTop: 1, borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField
            fullWidth
            multiline
            maxRows={4}
            placeholder="Type your request here..."
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            size="small"
          />
          <IconButton 
            color="primary" 
            onClick={handleSend}
            disabled={!inputMessage.trim()}
          >
            <SendIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatDrawer;